import { render, staticRenderFns } from "./TreeView2.vue?vue&type=template&id=b90155d4&scoped=true&"
import script from "./TreeView2.vue?vue&type=script&lang=js&"
export * from "./TreeView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90155d4",
  null
  
)

export default component.exports